import React, { ReactNode } from 'react'

import {
  ContainerLabel,
  ContainerWithButtons,
  Link,
  SheetModalHandleLabel,
} from './styles'

interface IProps {
  children: ReactNode
  onCancelButton?: () => void
  onSaveButton?: () => void
  showButtons?: boolean
  isCancelEnabled?: boolean
  isSaveEnabled?: boolean
}

export function SheetModalHandle({
  children,
  onCancelButton,
  onSaveButton,
  showButtons = false,
  isCancelEnabled = true,
  isSaveEnabled = true,
}: IProps) {
  return (
    <>
      {showButtons ? (
        <ContainerWithButtons>
          {onCancelButton && (
            <button
              onClick={onCancelButton}
              disabled={!isCancelEnabled}
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              <Link $isLinkEnabled={isCancelEnabled}>Cancel</Link>
            </button>
          )}
          <SheetModalHandleLabel>{children}</SheetModalHandleLabel>

          {onSaveButton && (
            <button
              onClick={onSaveButton}
              disabled={!isSaveEnabled}
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              <Link $isLinkEnabled={isSaveEnabled}>Save</Link>
            </button>
          )}
        </ContainerWithButtons>
      ) : (
        <ContainerLabel>
          <SheetModalHandleLabel>{children}</SheetModalHandleLabel>
        </ContainerLabel>
      )}
    </>
  )
}
